/**
 * Khmer (ភាសាខ្មែរ) dictionary. Must mirror every key of src/i18n/en.ts —
 * typed as `Dictionary` so missing keys fail the build.
 */
import type { Dictionary } from './en';

const km: Dictionary = {
  loading: 'កំពុងផ្ទុក...',
  nav: {
    aboutUs: 'អំពីយើង',
    solutions: 'ដំណោះស្រាយ',
    products: 'ផលិតផល',
    features: 'មុខងារ',
    portfolios: 'សមិទ្ធផល',
    contact: 'ទំនាក់ទំនង',
    blogs: 'អត្ថបទ',
    docs: 'ឯកសារណែនាំ',
  },
  footer: {
    tagline:
      'AKAS ផ្តល់ដំណោះស្រាយគ្រប់គ្រងអាជីវកម្មលើពពក ដើម្បីជួយឱ្យអាជីវកម្មដំណើរការរលូន និងបង្កើនផលិតភាព។',
    modules: 'ម៉ូឌុល',
    moreModules: 'ម៉ូឌុលផ្សេងទៀត',
    company: 'ក្រុមហ៊ុន',
    contact: 'ទំនាក់ទំនង',
    aboutUs: 'អំពីយើង',
    solutions: 'ដំណោះស្រាយ',
    liveDemos: 'ការបង្ហាញសាកល្បង',
    portfolios: 'សមិទ្ធផល',
    blogs: 'អត្ថបទ',
    location: 'រាជធានីភ្នំពេញ ប្រទេសកម្ពុជា',
    allRightsReserved: 'រក្សាសិទ្ធិគ្រប់យ៉ាង។',
    builtBy: 'បង្កើតឡើងនៅភ្នំពេញ ប្រទេសកម្ពុជា · ប្រព័ន្ធគ្រប់គ្រងអាជីវកម្មលើពពក សម្រាប់អាជីវកម្មដែលកំពុងរីកចម្រើន',
  },
  hero: {
    badge: 'ប្រព័ន្ធគ្រប់គ្រងអាជីវកម្មលើពពក សម្រាប់អាជីវកម្មដែលកំពុងរីកចម្រើន',
    title: 'គ្រប់គ្រងអាជីវកម្មទាំងមូល',
    titleAccent: 'ក្នុងប្រព័ន្ធតែមួយ',
    description:
      'បុគ្គលិក ការលក់ ស្តុក និងគណនេយ្យ តភ្ជាប់គ្នាក្នុងប្រព័ន្ធតែមួយ ទាំងភាសាខ្មែរ និងអង់គ្លេស។',
    primaryCta: 'សាកល្បងប្រើផ្ទាល់',
    secondaryCta: 'មើលមុខងារទាំងអស់',
  },
  process: {
    kicker: 'ដំណើរការតភ្ជាប់គ្នា',
    title: 'បញ្ចូលតែម្តង គ្រប់គ្នាឃើញភ្លាម',
    lead:
      'ផ្នែកលក់ ឃ្លាំង ធនធានមនុស្ស និងហិរញ្ញវត្ថុ ធ្វើការលើទិន្នន័យរួមតែមួយ — មិនត្រូវវាយបញ្ចូលឡើងវិញ ហើយក៏មិនត្រូវរក្សាតារាងគណនាដាច់ដោយឡែក។ សម្រង់តម្លៃដែលឈ្នះ ការទទួលស្តុក និងស្លឹកប្រាក់ខែ ចូលក្នុងសៀវភៅគណនីតែមួយ ដូច្នេះលេខរបស់អ្នកត្រូវគ្នាជានិច្ច។',
    openModule: 'ព័ត៌មានលម្អិត',
    guide: 'មគ្គុទ្ទេសក៍',
    items: [
      {
        title: 'ពីការជ្រើសរើសរហូតដល់ចាកចេញ',
        path: 'សំណើជ្រើសរើស → ចូលធ្វើការ → វត្តមាន/ឈប់សម្រាក → បើកប្រាក់ខែ → វាយតម្លៃ → ចាកចេញ',
        description:
          'ការជ្រើសរើសបុគ្គលិក ព័ត៌មានបុគ្គលិក វត្តមាន ការឈប់សម្រាក ការគណនាប្រាក់ខែ (រួមទាំងពន្ធ បេឡាជាតិសន្តិសុខសង្គម និងអាយុការ) ការវាយតម្លៃការងារ ការបណ្តុះបណ្តាល និងសេវាដោយខ្លួនឯង ស្ថិតលើកំណត់ត្រាបុគ្គលិកតែមួយ។',
      },
      {
        title: 'ពីអតិថិជនសក្ដានុពលដល់ប្រាក់ចូល',
        path: 'អតិថិជនសក្ដានុពល → អតិថិជន → ឱកាសលក់ → សម្រង់តម្លៃ → បញ្ជាលក់ → វិក្កយបត្រ → បង្កាន់ដៃ',
        description:
          'សម្រង់តម្លៃដែលបង្កើតក្នុងការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន អាចបម្លែងជាបញ្ជាលក់បានភ្លាម។ វិក្កយបត្រ KHQR ប្រាក់កក់ និងគណនីត្រូវទទួល ស្ថិតក្នុងការគ្រប់គ្រងចំណូល។ ការលក់តាមបញ្ជរ និងហាងអនឡាញ ក៏លក់ទំនិញពីបញ្ជីតែមួយដែរ។',
      },
      {
        title: 'ពីការទិញដល់ការទូទាត់',
        path: 'អ្នកផ្គត់ផ្គង់ → បញ្ជាទិញ → ទទួលទំនិញ → វិក្កយបត្រ → ទូទាត់',
        description:
          'បញ្ជាទិញ និងការទទួលទំនិញចូលស្តុក ប្រើអ្នកផ្គត់ផ្គង់រួមជាមួយផ្នែកចំណាយ។ វិក្កយបត្រទិញ ប្រាក់កក់ និងគណនីត្រូវបង់ ចុះបញ្ជីដោយស្វ័យប្រវត្តិ នៅពេលកំណត់គណនីគណនេយ្យរួច។',
      },
    ],
  },
  modules: {
    kicker: 'ម៉ូឌុលប្រព័ន្ធ',
    title: 'អ្វីដែលអ្នកទទួលបានពី AKAS',
    lead:
      'ចាប់ផ្តើមពីអ្វីដែលអ្នកត្រូវការថ្ងៃនេះ — បុគ្គលិក ការលក់ ការទិញ ស្តុក គណនេយ្យ គ្រឿងគិតលុយ ឬហាងអនឡាញ។ គ្រប់ម៉ូឌុលប្រើអតិថិជន ទំនិញ ទីតាំង និងដំណើរការអនុម័តរួមគ្នា ដូច្នេះពេលបន្ថែមម៉ូឌុលថ្មីក្រោយមក វាដំណើរការភ្លាម។',
    moduleDetails: 'ព័ត៌មានលម្អិត',
    userGuide: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់',
    browse: {
      kicker: 'មុខងារទាំងអស់',
      title: 'មើលថាតើម៉ូឌុលទាំងអស់ភ្ជាប់គ្នាដូចម្តេច',
      description:
        'ការគណនាប្រាក់ខែ ការលក់ ស្តុក និងគណនេយ្យ — ជាមួយព័ត៌មានលម្អិតពីមុខងារនីមួយៗ និងមគ្គុទ្ទេសក៍សម្រាប់គ្រប់ផ្នែក។',
      link: 'ស្វែងយល់មុខងារ →',
    },
  },
  platform: {
    kicker: 'ដំណើរការងាយ ប៉ុន្តែពិបាកប្រើខុស',
    title: 'កំណត់ច្បាប់នៅកន្លែងតែមួយ ម៉ូឌុលទាំងអស់ធ្វើតាម',
    description:
      'រចនាសម្ព័ន្ធក្រុមហ៊ុន ច្បាប់អនុម័ត ភាសា និងទម្រង់ឯកសារ កំណត់តែម្តងនៅផ្នែកគ្រប់គ្រងប្រព័ន្ធ ហើយនាយកដ្ឋាននីមួយៗទទួលយកតាម។ ដូច្នេះហើយ គ្រឿងគិតលុយរបស់គ្លីនិក ស្លឹកប្រាក់ខែ និងកំណត់ត្រាគណនី អាចនៅក្នុងប្រព័ន្ធតែមួយ — ហើយការបើកសាខាថ្មីក៏មិនមែនជាគម្រោងថ្មីដែរ។',
    platformLink: 'ព័ត៌មានអំពីវេទិកា',
    adminGuide: 'មគ្គុទ្ទេសក៍អ្នកគ្រប់គ្រងប្រព័ន្ធ',
    items: [
      {
        title: 'កំណត់ច្បាប់តាមតម្រូវការអ្នក',
        body: 'រៀបចំផ្លូវអនុម័តសម្រាប់ការឈប់សម្រាក សម្រង់តម្លៃ វិក្កយបត្រ និងស្តុក។ ពេលអាជីវកម្មផ្លាស់ប្តូរ អ្នកក៏កែបានភ្លាម — មិនត្រូវរង់ចាំអ្នកផ្គត់ផ្គង់ ហើយក៏មិនត្រូវសាងសង់ប្រព័ន្ធថ្មី។',
      },
      {
        title: 'ឱ្យមើលតែអ្វីដែលគួរមើល',
        body: 'តួនាទីនីមួយៗមានម៉ឺនុយរៀងៗខ្លួន ហើយជំហានសំខាន់ដូចជាការគណនាប្រាក់ខែ មានការការពារការចូលបន្ថែម។',
      },
      {
        title: 'គ្រប់គ្នាធ្វើការជាភាសារបស់ខ្លួន',
        body: 'ភាសាខ្មែរ និងអង់គ្លេស មានពេញទាំងប្រព័ន្ធ — អេក្រង់ ឯកសារ និងស្លឹកប្រាក់ខែ។ ត្រូវការភាសាថ្មីពេលណា ក៏បន្ថែមបាន។',
      },
      {
        title: 'កែប្រព័ន្ធឱ្យសមនឹងអ្នក',
        body: 'បន្ថែមវាលទិន្នន័យ និងរៀបចំអេក្រង់ឡើងវិញតាមតម្រូវការវិស័យរបស់អ្នក ដោយគ្រាន់តែចង្អុល និងចុច។',
      },
      {
        title: 'រចនាសម្ព័ន្ធក្រុមហ៊ុនតែមួយ',
        body: 'សាខា នាយកដ្ឋាន ឃ្លាំង រូបិយប័ណ្ណ និងឆ្នាំហិរញ្ញវត្ថុ កំណត់តែម្តង — ម៉ូឌុលទាំងអស់ធ្វើតាម។',
      },
      {
        title: 'សួរបានភ្លាម ជំនួសការរង់ចាំរបាយការណ៍',
        body: 'ជំនួយការបញ្ញាសិប្បនិម្មិតឆ្លើយសំណួរអំពីទិន្នន័យអាជីវកម្មរបស់អ្នក — ប្រើសេវាបញ្ញាសិប្បនិម្មិតដែលអ្នកជ្រើសរើស ឬដំណើរការក្នុងប្រព័ន្ធរបស់អ្នកផ្ទាល់។',
      },
      {
        title: 'ការទូទាត់ និងប្រាក់ខែក្នុងស្រុក',
        body: 'វិក្កយបត្រស្កេនបង់តាម KHQR ពន្ធលើប្រាក់ខែ បេឡាជាតិសន្តិសុខសង្គម និងរបាយការណ៍អាយុការ ជាផ្នែកមួយនៃផលិតផល — មិនត្រូវរៀបចំក្នុងតារាងគណនាដាច់ដោយឡែកទេ។',
      },
      {
        title: 'ត្រៀមរួចសម្រាប់ការត្រួតពិនិត្យ',
        body: 'លេខរៀងឯកសារដោយស្វ័យប្រវត្តិ និងប្រវត្តិនៃការផ្លាស់ប្តូរលើទិន្នន័យសំខាន់ — អ្នកសវនកម្មអាចពិនិត្យ ហើយយល់ព្រមបានភ្លាម។',
      },
    ],
  },
  features: {
    badge: 'ហេតុអ្វីជ្រើសរើស AKAS',
    title: 'បង្កើតជាប្រព័ន្ធគ្រប់គ្រងអាជីវកម្មពិតប្រាកដ មិនមែនកម្មវិធីដាច់ៗគ្នាទេ',
    description:
      'វាលផ្ទាល់ខ្លួន ការបកប្រែ និងដំណើរការការងារ អាចដោះស្រាយសំណើ «យើងធ្វើការខុសគ្នា» បានភាគច្រើន។ មើលវីដេអូបង្ហាញ រួចអានមគ្គុទ្ទេសក៍ម៉ូឌុលនៅ docs.akas.co។',
    items: [
      {
        title: 'ថ្ងៃបើកប្រាក់ខែ ដែលអ្នកលែងត្រូវព្រួយ',
        description:
          'ពន្ធលើប្រាក់ខែ បេឡាជាតិសន្តិសុខសង្គម អាយុការ និងរបាយការណ៍ផ្ទេរប្រាក់តាមធនាគារ ចេញពីការគណនាប្រាក់ខែរួចស្រេច — ក្រុមហិរញ្ញវត្ថុគ្រាន់តែពិនិត្យ ជំនួសការរៀបចំឡើងវិញ ហើយបុគ្គលិកទទួលស្លឹកប្រាក់ខែជាភាសាខ្មែរ ឬអង់គ្លេស នៅលើទូរស័ព្ទរបស់ខ្លួន។',
      },
      {
        title: 'ការសម្រេចចិត្តមិនរង់ចាំលើតុ',
        description:
          'សំណើឈប់សម្រាក ការទិញ សម្រង់តម្លៃ និងសំណើស្តុក ត្រូវបញ្ជូនទៅអ្នកអនុម័តត្រឹមត្រូវដោយស្វ័យប្រវត្តិ។ បុគ្គលិកដាក់សំណើដោយខ្លួនឯង ជំនួសក្រដាស ហើយអ្នកគ្រប់គ្រងអនុម័តពីទូរស័ព្ទ — ជាមួយកំណត់ត្រាច្បាស់លាស់នៅពីក្រោយការយល់ព្រមនីមួយៗ។',
      },
      {
        title: 'លេខតែមួយ ដែលអ្នកទុកចិត្តបាន',
        description:
          'អតិថិជន ទំនិញ ឬអ្នកផ្គត់ផ្គង់ បញ្ចូលតែម្តង ហើយផ្នែកលក់ ស្តុក គ្រឿងគិតលុយ និងគណនេយ្យ ប្រើទិន្នន័យដូចគ្នា។ ប្រាក់ចូលលឿនជាងមុន ដោយសារវិក្កយបត្របង់បានភ្លាម ហើយស្តុកក៏លែងស្ថិតនៅលើតារាងគណនាទៀត។',
      },
      {
        title: 'គ្រប់គ្រងបាន ដោយមិនត្រូវតាមដានគ្រប់ជំហាន',
        description:
          'តួនាទីនីមួយៗឃើញតែផ្នែករបស់ខ្លួន។ ការផ្លាស់ប្តូរសំខាន់ត្រូវកត់ត្រា ឯកសារធ្វើតាមលេខរៀងរបស់អ្នក ហើយអ្នកអនុម័ត មិនដែលជាអ្នកចុះបញ្ជីគណនេយ្យដូចគ្នានោះទេ។',
      },
    ],
    videos: [
      {
        title: 'ប្រព័ន្ធកែតម្រូវតាមតម្រូវការ',
        description: 'ការបង្ហាញពីការរៀបចំទម្រង់អេក្រង់ និងការកែតម្រូវ',
      },
      {
        title: 'ដំណើរការអនុម័ត',
        description: 'រចនាដំណើរការអនុម័តនៅក្នុង AKAS។',
      },
    ],
    detailLink: 'មើលថា AKAS ធ្វើអ្វីខ្លះសម្រាប់អាជីវកម្មរបស់អ្នក →',
    detailNote:
      'ប្រាក់ខែដែលរៀបចំរបាយការណ៍ដោយខ្លួនឯង វិក្កយបត្រដែលអតិថិជនបង់លឿនជាងមុន ស្តុកដែលអ្នកទុកចិត្តបាន និងការអនុម័តដែលដើរទៅមុខ។',
  },
  testimonials: {
    badge: 'មតិអតិថិជន',
    title: 'អតិថិជនរបស់យើងនិយាយអ្វី',
    items: [
      {
        content:
          'AKAS បានផ្លាស់ប្តូររបៀបដែលយើងគ្រប់គ្រងប្រតិបត្តិការអាជីវកម្ម។ ម៉ូឌុលលើពពករបស់វា ភ្ជាប់ការគ្រប់គ្រងទំនាក់ទំនងអតិថិជន និងគណនេយ្យចូលគ្នាយ៉ាងរលូន។',
        author: 'Chan Sombath',
        position: 'នាយកប្រតិបត្តិ, OWP',
      },
      {
        content:
          'AKAS បានធ្វើឱ្យប្រតិបត្តិការរបស់យើងប្រសើរឡើង ជាមួយប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្សលើពពកដ៏ពេញលេញ។ ដំណើរការធនធានមនុស្សកាន់តែងាយស្រួល ហើយប្រសិទ្ធភាពកើនឡើងគួរឱ្យកត់សម្គាល់។',
        author: 'Hour Chansokun',
        position: 'នាយករដ្ឋបាល, iDE Cambodia',
      },
      {
        content:
          'AKAS បានផ្លាស់ប្តូរប្រតិបត្តិការធនធានមនុស្សរបស់យើង តាមរយៈវេទិកាលើពពកដែលរួមបញ្ចូលគ្រប់យ៉ាង។ ដំណើរការការងារកាន់តែសាមញ្ញ ហើយផលិតភាពរបស់យើងកើនឡើងយ៉ាងច្រើន។',
        author: 'Tham Thavy',
        position: 'ប្រធានផ្នែកធនធានមនុស្ស, ICF Cambodia',
      },
    ],
  },
  notFound: {
    title: 'រកមិនឃើញទំព័រ | AKAS',
    description: 'រកមិនឃើញទំព័រដែលអ្នកស្នើសុំនៅលើ AKAS។',
    heading: 'ទំព័រនេះមិនអាចប្រើបានទេ',
    body: 'តំណអាចខូច ឬទំព័រអាចត្រូវបានដកចេញ។',
    backHome: 'ត្រឡប់ទៅទំព័រដើម',
  },
};

export default km;
